<ng-container *ngIf="!errorType">
  <div *ngIf="!loaded" class="loader">
    <loader-overlay
      [darkOnly]="[ 'popup'].includes(previewMode)"
      [styles]="{ backgroundColor: 'transparent', backdropFilter: 'none' }"
    >
    </loader-overlay>
  </div>
  <img
    #imgRef
    *ngIf="srcUrl"
    alt=""
    class="preview-item"
    [src]="srcUrl | safe: 'resource'"
  />
</ng-container>
<ng-container *ngIf="errorType">
  <error-preview
    [errorType]="errorType"
    [previewMode]="previewMode"
    [icon]="model.icon"
    (reload)="reload.emit()"
    (download)="download.emit()"
    (open)="open.emit()"
  >
  </error-preview>
</ng-container>
